import styled from "styled-components";

export const Box = styled.div`

.interDisplay {
    font-family: InterDisplay;
  }
  .defaultText {
    font-family: -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen,
      Ubuntu, Cantarell, sans-serif;
  }
  .imgconv-container {
    // background: #f4f7fa;
    // min-height: 100vh;
    font-family: system-ui, -apple-system, sans-serif;
    // padding: 2rem 1rem;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .imgconv-wrapper {
    background-color: white;
    border-radius: 1.5rem;
    padding: 2.5rem;
    box-shadow: 0 8px 16px rgba(0, 0, 0, 0.05);
    max-width: 72rem;
    width: 100%;
    margin: 0 auto;
  }

  .imgconv-header {
    text-align: center;
    margin-bottom: 2.5rem;
  }

  .imgconv-title {
    font-size: 2.25rem;
    font-weight: 800;
    color: #1a202c;
    margin-bottom: 0.75rem;
    letter-spacing: -0.025em;
  }

  .imgconv-description {
    color: #718096;
    font-size: 1.125rem;
    margin-bottom: 1.25rem;
  }

  .imgconv-format-info {
    display: flex;
    gap: 0.75rem;
    flex-wrap: wrap;
    justify-content: center;
  }

  .imgconv-badge {
    background-color: #edf2f7;
    padding: 0.5rem 1rem;
    border-radius: 9999px;
    font-size: 0.875rem;
    font-weight: 500;
    color: #4a5568;
    transition: background-color 0.2s;
  }

  .imgconv-badge:hover {
    background-color: #e2e8f0;
  }

  .imgconv-options {
    margin-bottom: 2.5rem;
    display: flex;
    justify-content: center;
  }

  .imgconv-format-selector {
    display: flex;
    align-items: center;
    gap: 2rem; /* Increased gap for more space between elements */
    color: #2d3748;
    flex-wrap: wrap;
    background-color: #f7fafc;
    padding: 1.25rem;
    border-radius: 0.75rem;
    box-shadow: inset 0 2px 4px rgba(0, 0, 0, 0.05);
  }

  .imgconv-label {
    font-size: 1.125rem;
    font-weight: 600;
    color: #2d3748;
  }

  .imgconv-format-select-wrapper {
    position: relative;
    display: inline-block;
    width: 160px;
    padding: 0 0.5rem; /* Added padding for spacing around dropdowns */
  }

  .imgconv-format-select-wrapper::after {
    content: "";
    position: absolute;
    right: 1rem;
    top: 50%;
    transform: translateY(-50%);
    width: 0;
    height: 0;
    border-left: 6px solid transparent;
    border-right: 6px solid transparent;
    border-top: 6px solid white;
    pointer-events: none;
    z-index: 1;
  }

  select#imgconv-source-format,
  select#imgconv-target-format {
    color: #fff !important;
    background-color: #2d3748 !important;
  }

  select#imgconv-source-format option,
  select#imgconv-target-format option {
    background-color: #2d3748;
    color: white;
  }

  .imgconv-format-select {
    width: 100%;
    background-color: #2d3748;
    color: white;
    padding: 0.75rem 2.5rem 0.75rem 1rem;
    border-radius: 0.5rem;
    border: none;
    appearance: none;
    cursor: pointer;
    font-size: 1rem;
    font-weight: 500;
    transition: background-color 0.2s, transform 0.1s;
  }

  .imgconv-format-select:hover {
    background-color: #4a5568;
    transform: translateY(-1px);
  }

  .imgconv-format-select:focus {
    outline: none;
    box-shadow: 0 0 0 4px rgba(59, 130, 246, 0.2);
  }

  .imgconv-dropzone {
    border: 3px dashed #e2e8f0;
    border-radius: 1rem;
    padding: 3rem 1.5rem;
    text-align: center;
    cursor: pointer;
    background-color: #fafafa;
    transition: border-color 0.2s, background-color 0.2s, transform 0.1s;
  }

  .imgconv-dropzone:hover {
    border-color: #4299e1;
    background-color: #f0f9ff;
    transform: scale(1.01);
  }

  .imgconv-dropzone-icon {
    color: #a0aec0;
    margin-bottom: 1.5rem;
    transition: color 0.2s;
  }

  .imgconv-dropzone:hover .imgconv-dropzone-icon {
    color: #4299e1;
  }

  .imgconv-dropzone-text {
    color: #4a5568;
    margin-bottom: 0.75rem;
    font-size: 1.25rem;
    font-weight: 600;
  }

  .imgconv-dropzone-hint {
    color: #718096;
    font-size: 0.875rem;
    font-style: italic;
  }

  .imgconv-preview-grid {
    display: grid;
    grid-template-columns: repeat(auto-fill, minmax(160px, 1fr));
    gap: 1.5rem;
    margin-top: 2rem;
  }

  .imgconv-preview-item {
    position: relative;
    border-radius: 0.75rem;
    overflow: hidden;
    aspect-ratio: 1;
    box-shadow: 0 4px 6px rgba(0, 0, 0, 0.05);
    transition: transform 0.2s;
  }

  .imgconv-preview-item:hover {
    transform: translateY(-2px);
  }

  .imgconv-preview-image {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: 0.75rem;
  }

  .imgconv-preview-overlay {
    position: absolute;
    inset: 0;
    background-color: rgba(0, 0, 0, 0.6);
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1rem;
    font-weight: 500;
    opacity: 0;
    transition: opacity 0.2s;
  }

  .imgconv-preview-item:hover .imgconv-preview-overlay {
    opacity: 1;
  }

  .imgconv-error-text {
    position: absolute;
    bottom: 0;
    left: 0;
    right: 0;
    background-color: rgba(220, 38, 38, 0.9);
    color: white;
    padding: 0.5rem;
    font-size: 0.75rem;
    text-align: center;
    border-bottom-left-radius: 0.75rem;
    border-bottom-right-radius: 0.75rem;
  }

  .imgconv-remove-button {
    position: absolute;
    top: 0.75rem;
    right: 0.75rem;
    width: 2.25rem;
    height: 2.25rem;
    border-radius: 9999px;
    background-color: rgba(0, 0, 0, 0.6);
    border: none;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    transition: background-color 0.2s, opacity 0.2s;
    opacity: 0;
  }

  .imgconv-preview-item:hover .imgconv-remove-button {
    opacity: 1;
  }

  .imgconv-remove-button:hover {
    background-color: rgba(220, 38, 38, 0.9);
  }

  .imgconv-buttons {
    display: flex;
    gap: 1.25rem;
    justify-content: center;
    margin-top: 2.5rem;
  }

  .imgconv-button {
    display: flex;
    align-items: center;
    gap: 0.75rem;
    padding: 1rem 2rem;
    border-radius: 0.75rem;
    font-weight: 600;
    font-size: 1rem;
    border: none;
    cursor: pointer;
    transition: background-color 0.2s, transform 0.1s, box-shadow 0.2s;
  }

  .imgconv-button:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    transform: none;
  }

  .imgconv-button-primary {
    background-color: #3182ce;
    color: white;
    box-shadow: 0 4px 12px rgba(49, 130, 206, 0.3);
  }

  .imgconv-button-primary:hover:not(:disabled) {
    background-color: #2b6cb0;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(49, 130, 206, 0.4);
  }

  .imgconv-button-success {
    background-color: #38a169;
    color: white;
    box-shadow: 0 4px 12px rgba(56, 161, 105, 0.3);
  }

  .imgconv-button-success:hover:not(:disabled) {
    background-color: #2f855a;
    transform: translateY(-2px);
    box-shadow: 0 6px 16px rgba(56, 161, 105, 0.4);
  }

  .imgconv-button-icon {
    width: 1.5rem;
    height: 1.5rem;
  }

  .imgconv-hidden {
    display: none;
  }

  .imgconv-error {
    background-color: #fff5f5;
    border: 1px solid #feb2b2;
    border-radius: 0.75rem;
    color: #c53030;
    font-size: 0.875rem;
    margin-top: 1.5rem;
    padding: 1rem;
    text-align: center;
  }

  @media (max-width: 768px) {
  .imgconv-container {
    padding: 0.5rem !important; 
  }

  .imgconv-wrapper {
    padding: 1rem !important;
    margin: 0 !important;      
    border-radius: 0.75rem;
  }

  .imgconv-title {
    font-size: 1.5rem !important;
    margin-bottom: 1rem !important;
  }

  .imgconv-description {
    font-size: 0.95rem !important;
    margin-bottom: 1rem !important;
  }

  .imgconv-format-selector {
    flex-direction: column !important;
    gap: 1rem !important;
    padding: 0.5rem !important;
  }

  .imgconv-format-select-wrapper {
    width: 100% !important;
    max-width: 200px;
    padding: 0 !important;
  }

  .imgconv-dropzone {
    padding: 1.25rem !important;
  }

  .imgconv-dropzone-text {
    font-size: 1rem !important;
    margin-bottom: 0.5rem !important;
  }

  .imgconv-preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(140px, 1fr));
    gap: 0.75rem !important;
    margin-top: 1rem !important;
  }

  .imgconv-buttons {
    flex-direction: column !important;
    gap: 0.75rem !important;
    margin-top: 1.5rem !important;
  }

  .imgconv-button {
    padding: 0.6rem 1rem !important;
    font-size: 0.85rem !important;
    width: 100% !important;
  }
}

@media (max-width: 480px) {
  .imgconv-title {
    font-size: 1.3rem !important;
  }

  .imgconv-description {
    font-size: 0.85rem !important;
  }

  .imgconv-dropzone-text {
    font-size: 0.9rem !important;
  }

  .imgconv-dropzone-hint {
    font-size: 0.7rem !important;
  }

  .imgconv-preview-grid {
    grid-template-columns: repeat(auto-fill, minmax(120px, 1fr));
    gap: 0.5rem !important;
  }
    .imgconv-format-selector {
  width: 100%;
}
  .imgconv-options {
  width: 100%;
}
}
`;
